module.exports = __webpack_public_path__ + "static/media/ic-pontos.49fa2b15.svg";